$(function () {
  'use strict';

  var $selector = $('#report-item-users-selector');
  var $keyword = $('#js-users-keyword');
  var $selectTargetStepId = $('#js-select-target-step-id');

  var last_search_response = null;

  /**
   * ユーザを選択／非選択する
   * @param $checkbox {jQuery}  チェックボックス
   */
  function selectUser($checkbox) {
    var $parent = $checkbox.parent();
    if ($checkbox.is(':checked')) {
      $('<input>').attr({type: 'hidden', name: 'users[]', value: $checkbox.data('user-id')}).appendTo($parent);
    } else {
      $parent.find('input[value="' + $checkbox.data('user-id') + '"]').remove();
    }
  }

  /**
   * 部署によるフィルタリング
   * @param department  {string}  部署名
   */
  function searchByDepartment(department) {
    $keyword.val(department);
    $keyword.trigger('changeKeyword');

    scrollToForm();
  }

  /**
   * 検索フォームが表示されるようスクロールする
   */
  function scrollToForm() {
    var headerOffset = $('#header').height();
    var scrollTop = $(window).scrollTop();
    var viewportHeight = window.innerHeight;
    var formOffsetTop = $('#js-search-form').offset().top;

    // フォームが画面外の場合、スクロールして表示する
    if (scrollTop + headerOffset > formOffsetTop || scrollTop + viewportHeight < formOffsetTop) {
      $('html, body').animate({scrollTop: formOffsetTop - headerOffset}, 400, 'swing');
    }
  }

  // ユーザの一括選択
  $('.invite-members input[type="checkbox"].select-all-users').change(function () {
    var $this = $(this);
    var $checks = $selector.find('input[type="checkbox"]' + 'input[data-user-id]');

    $checks.prop('checked', $this.is(':checked'));
    $.each($checks, function () {
      selectUser($(this));
    });
  });

  // 個別ユーザーのcheckbox の on/off で input type=hidden の 追加/削除を行う
  $selector.on('change', 'input[type="checkbox"]' + 'input[data-user-id]', function () {
    selectUser($(this));
  });

  // 部署を選択した際に絞り込み
  $selector.on('click', '.invite-members__list__info__dept strong', function () {
      if ($(this).data('department-name')) {
          searchByDepartment($(this).data('department-name'));
      } else {
          searchByDepartment($(this).html());
      }
  });

  var show_records = function () {
      var userRows = '';
      $.each(last_search_response, function (i, item) {
          if ($selector.find('tr[data-user-id="' + item.user.id + '"]').length > 0) return true;

          userRows += buildRow(item.user);
      });
      $selector.append(userRows);
  };

  var timerId = null;

  // キーワード変更
  $keyword.on('changeKeyword', function () {
    var keyword = $(this).val();
    var selectTargetStepId = $selectTargetStepId.val();
    // console.log('value=' + keyword + ' (' + keyword.length + ')');

    if (timerId) clearTimeout(timerId)

    timerId = setTimeout( function () {
      $.ajax({
        url: '/users/search.json',
        data: {keyword: keyword, select_target_step_id: selectTargetStepId, limit: 100},
        type: 'get'
      }).done(function (response) {

        // 通信中にkeyword変わってたら何もしない
        if (keyword !== $keyword.val()) return;
        last_search_response = response;

        // console.log('Done: ', response);
        // 未選択時の案内を削除
        var $notice = $selector.find('tr.notice');
        if ($notice.length > 0) {
          $notice.remove();
        }

        // 表示されている未選択のユーザを削除
        var $unchecked = $selector.find('tr[data-user-id] input[type="checkbox"]:not(:checked)');
        $.each($unchecked, function (i, item) {
          item.parentElement.parentElement.remove();
        });

        // ユーザ一覧を表示
        show_records();
      }).fail(function () {
        console.log('Failed');
      })
    }, 400);
  }).on('keydown', function (e) {
    // 検索キーワード入力中の Enter 押下による submit を無効化
    if ((e.which && e.which === 13) || (e.keyCode && e.keyCode === 13)) {
      return false;
    }
  });

  // 部署選択 SELECT
  $('select.js-department-select-for-user-selector').on('change', function() {
      var selected = $(this).children(':selected');
      if (selected) {
          var name_with_parents = selected.data('name-with-parents');
          if (name_with_parents) {
              searchByDepartment(name_with_parents);
          }
      }
  });


  /**
   * 行（ユーザ情報）を作成する
   *
   * @param user  {object}
   * @returns     {string}
   */
  function buildRow(user) {
    return (
      '<tr data-user-id="' + user.id + '">' + buildCheckBox(user) + buildThumbnail(user) + buildUserData(user) + '</tr>'
    );
  }

  /**
   * checkbox カラムを作成する
   * checkbox の on/off で input type=hidden の 追加/削除を行う
   *
   * @param user  {object}
   * @returns     {string}
   */
  function buildCheckBox(user) {
    return (
      '<td class="invite-members__list__btn p-l15">' +
      '<input type="checkbox" id="user-' + user.id + '-checkbox" data-user-id="' + user.id + '">' +
      '</td>'
    );
  }

  /**
   * ユーザサムネイルカラムを作成する
   *
   * @param user  {object}
   * @returns     {string}
   */
  function buildThumbnail(user) {
    return (
      '<td class="invite-members__list__thumb p-h10">' +
      '<label for="user-' + user.id + '-checkbox">' +
      '<div class="user__thumb user-image user-image--45 img--circled">' +
      '<img src="' + user.image_path + '" alt="' + user.name + '" width="45" height="45" />' +
      '</div>' +
      '</label>' +
      '</td>'
    );
  }

  /**
   * ユーザ情報カラムを作成する
   *
   * @param user  {object}
   * @returns     {string}
   */
  function buildUserData(user) {
    // ユーザ名
    var name = '<label for="user-' + user.id + '-checkbox">' +
      '<span class="invite-members__list__info__name">' + user.name + '</span>' + '</label><br />';

    // 部署
    var department = '';
    $.each(user.departments, function (i, department_names) {
      var name_with_parents = '';
      $.each(department_names, function (i, name) {
        name_with_parents = name_with_parents + ' ' + name;
        department += '<span class="invite-members__list__info__dept"><strong data-department-name="' + name_with_parents + '">' + name + '</strong></span>';
      });
    });

    return ('<td class="invite-members__list__info">' + name + department + '</td>');
  }

  /**
   * キーワードの変更監視
   * @param fps {number}  イベント実行頻度
   */
  (function keywordObserver(fps) {
    fps = fps || 60;
    var interval = 1000 / fps,
      prevValue = $keyword.val(),
      timerID = null,
      composition = false;

    $keyword.on('compositionstart', function (event) {
      composition = true;
    }).on('compositionend', function (event) {
      composition = false;
    });

    var observe = function (val) {
      // キーワード変更
      if (val !== prevValue && composition === false) {
        $keyword.trigger('changeKeyword');
        prevValue = val;
      }
    };

    // 変更監視
    $keyword.on('focus mouseover', function () {
      if (!timerID) {
        timerID = setInterval(function () {
          observe($keyword.val());
        }, interval);
      }
    }).on('blur', function () {
      clearInterval(timerID);
      timerID = null;
    }).on('mouseout', function () {
      // 検索フォームにフォーカスがある場合は監視継続
      if (!$(':focus').is($keyword)) {
        clearInterval(timerID);
        timerID = null;
      }
    });
  })(5);
});
